import { Component, Input, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-horizontal-bar-dots-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './horizontal-bar-dots-chart.html',
  styleUrls: ['./horizontal-bar-dots-chart.scss']
})
export class HorizontalBarDotsChart {
  @Input() data: {
    name: string;
    values: number[]; // Três valores percentuais para os pontos
    value: number; // VALOR EM REAIS
    valuePositions?: string[]; // Array com posições: 'top' ou 'bottom' para cada valor
  }[] = [
    {
      name: 'Eficiência Operacional',
      values: [30, 70, 50],
      value: 1500.50,
      valuePositions: ['top', 'bottom', 'top']
    },
    {
      name: 'Satisfação do Cliente',
      values: [40, 85, 65],
      value: 2750.00,
      valuePositions: ['bottom', 'top', 'bottom']
    },
    {
      name: 'Taxa de Conversão',
      values: [25, 60, 45],
      value: 890.75,
      valuePositions: ['top', 'bottom', 'top']
    }
  ];

  @Input() barColor: string = '#4CC7F4';
  @Input() title: string = '';

  // Cores para os pontos
  dotColors: string[] = ['#001E50', '#00B0F0', '#6A767D'];

  // Legenda
  legendItems = [
    { color: '#001E50', label: 'Concessionária' },
    { color: '#00B0F0', label: 'Referência Regional' },
    { color: '#6A767D', label: 'Referência Nacional' }
  ];

  // Tooltip state
  activeTooltipIndex: number | null = null;
  tooltipStyle: any = {};
  private hideTimeout: any;

  // MÉTODO ADICIONADO: Calcula posição limite para valores > 100%
  getPosition(value: number): string {
    // Limita a posição a 100% se o valor for maior
    if (value > 100) {
      return '100%';
    }
    // Para valores normais, usa o valor como porcentagem
    return value + '%';
  }

  showTooltip(index: number, event: MouseEvent): void {
    // Limpa timeout anterior se existir
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    this.activeTooltipIndex = index;
    this.updateTooltipPosition(event);
  }

  hideTooltip(): void {
    // Usamos timeout para permitir que o mouse vá para o tooltip
    this.hideTimeout = setTimeout(() => {
      this.activeTooltipIndex = null;
    }, 100);
  }

  cancelHideTooltip(): void {
    // Cancela o esconder se o mouse entrou no tooltip
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }

  hideTooltipImmediately(): void {
    // Esconde imediatamente (quando o mouse sai do tooltip)
    this.activeTooltipIndex = null;
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }

  updateTooltipPosition(event: MouseEvent): void {
    if (this.activeTooltipIndex === null) return;

    // Posiciona o tooltip relativo à barra
    const barElement = (event.target as HTMLElement).closest('.bar-item');
    if (!barElement) return;

    const barRect = barElement.getBoundingClientRect();

    // Posiciona o tooltip centralizado na barra
    const x = barRect.left + (barRect.width / 2);
    const y = barRect.top - 10; // 10px acima da barra

    // Ajustar para não sair da tela
    const tooltipWidth = 220;
    const viewportWidth = window.innerWidth;

    let finalX = x - (tooltipWidth / 2);

    // Verificar borda direita
    if (finalX + tooltipWidth > viewportWidth) {
      finalX = viewportWidth - tooltipWidth - 10;
    }

    // Verificar borda esquerda
    if (finalX < 10) {
      finalX = 10;
    }

    this.tooltipStyle = {
      'left.px': finalX,
      'top.px': y
    };
  }

  // Listener global para cliques fora
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const clickedInsideTooltip = (event.target as HTMLElement).closest('.bar-tooltip');
    const clickedInsideBar = (event.target as HTMLElement).closest('.bar-item');

    if (!clickedInsideTooltip && !clickedInsideBar) {
      this.hideTooltipImmediately();
    }
  }
}
